var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["pr overflow-hidden", {'flex justify-center': !_vm.widgetLoaded, modal: _vm.widget.modal}, _vm.$css(_vm.styles.container)],attrs:{"id":"widget-container"}})}
var staticRenderFns = []

export { render, staticRenderFns }